export function SessionsPage() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="text-center">
        <h2 className="text-lg font-semibold text-espresso">Sessions</h2>
        <p className="mt-2 text-sm text-bark">
          Session history lands in Phase 2.
        </p>
      </div>
    </div>
  );
}
